import { apiClient } from '@/shared/api/client';
import { filterActiveEntityRows } from '../../../sgEntityActiveRowFilter';

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

export interface EntityControllerManageRow {
  ctrlIdx: string;
  referencesContactCd: string;
  fullName: string;
  categoryCd: string;
  legalForm: string;
  jurisdictionCd: string;
  incorporationStatute: string;
  corporateEntityRegister: string;
  contactRegNo: string;
  regNo: string;
  nonRegNo: string;
  becomingDate: string;
  cessationDate: string;
}

function mapControllerRow(raw: Record<string, unknown>): EntityControllerManageRow | null {
  const fullName = trim(raw.FULL_NAME ?? raw.fullName);
  if (!fullName) return null;
  return {
    ctrlIdx: trim(raw.CTRL_IDX ?? raw.ctrlIdx),
    referencesContactCd: trim(raw.REFERENCES_CONTACT_CD ?? raw.referencesContactCd),
    fullName,
    categoryCd: trim(raw.CATEGORY_CD ?? raw.categoryCd),
    legalForm: trim(raw.LEGAL_FORM ?? raw.legalForm),
    jurisdictionCd: trim(raw.JURISDICTION ?? raw.jurisdiction),
    incorporationStatute: trim(raw.INCORPORATION_STATUTE ?? raw.incorporationStatute),
    corporateEntityRegister: trim(raw.CORPORATE_ENTITY_REGISTER ?? raw.corporateEntityRegister),
    contactRegNo: trim(raw.CONTACT_REG_NO ?? raw.contactRegNo),
    regNo: trim(raw.REG_NO ?? raw.regNo),
    nonRegNo: trim(raw.NON_REG_NO ?? raw.nonRegNo),
    becomingDate: trim(raw.BECOMING_DATE ?? raw.becomingDate),
    cessationDate: trim(raw.CESSATION_DATE ?? raw.cessationDate),
  };
}

/** L_CONTROLLERMANAGE — active controllers (no cessation date) for entity */
export async function fetchActiveEntityControllers(entityCd: string): Promise<EntityControllerManageRow[]> {
  const ec = trim(entityCd);
  if (!ec) return [];
  try {
    const res: any = await apiClient.get(
      `/startTask/common/controllers-all-by-entity/${encodeURIComponent(ec)}`,
    );
    const rows: any[] = Array.isArray(res?.controllers)
      ? res.controllers
      : Array.isArray(res?.data?.controllers)
        ? res.data.controllers
        : [];
    return filterActiveEntityRows(rows as Record<string, unknown>[])
      .map((r) => mapControllerRow(r))
      .filter((r): r is EntityControllerManageRow => !!r && !r.cessationDate);
  } catch (e) {
    console.warn('[confirmationControllers] fetch controllers failed:', e);
    return [];
  }
}
